<template>
    <div class="c-animation" :style="style" ref="lavContainer" ></div>
</template>

<script>
  import lottie from 'lottie-web';

  export default {
    props: {
      options: {
        type: Object,
        required: true
      },
      height: Number,
      width: Number,
    },

    data () {
      return {
        style: {
          width: this.width ? `${this.width}px` : '100%',
          height: this.height ? `${this.height}px` : '100%',
          overflow: 'hidden',
          margin: '0 auto'
        }
      }
    },
    methods: {
    },
    mounted () {
      this.anim = lottie.loadAnimation({
          container: this.$refs.lavContainer,
          renderer: 'svg',
          loop: false,
          autoplay: this.options.autoplay !== false,
          animationData: this.options.animationData,
          rendererSettings: this.options.rendererSettings
        }
      );
      lottie.setQuality(3);

      this.$emit('animCreated', this.anim);
    }
  }
</script>

<style lang="scss" scoped>
.c-animation{
    &::v-deep{
        svg path{
            stroke:$color-primary !important;
        }
    }
}
</style>